import React, { useEffect } from 'react';
import { ConfigProvider, Layout } from 'antd';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from './redux/hooks';
import LoginScreen from './screens/Login/LoginScreen';
import HomeScreen from './screens/Home/HomeScreen';
import { IncidentCreationScreen } from './screens/Incident/IncidentCreationScreen';
import SessionRecovery from './components/SessionRecovery/SessionRecovery';
import { ShzoomAntTheme } from './theme/ShzoomTheme';
import { storageManager } from './utils/storageManager';

const { Content } = Layout;

function App() {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  
  useEffect(() => {
    // Auto cleanup storage on app load if needed
    const performAutoCleanup = async () => {
      try {
        await storageManager.autoCleanup();
      } catch (error) {
        console.error('Storage auto-cleanup error:', error);
      }
    };
    
    performAutoCleanup();
  }, []);

  return (
    <ConfigProvider theme={ShzoomAntTheme}>
      <Router>
        <Layout style={{ minHeight: '100vh' }}>
          <Content>
            {isLoggedIn && <SessionRecovery />}
            <Routes>
              <Route 
                path="/login" 
                element={isLoggedIn ? <Navigate to="/home" /> : <LoginScreen />} 
              />
              <Route 
                path="/home" 
                element={isLoggedIn ? <HomeScreen /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/vin-scan" 
                element={isLoggedIn ? <Navigate to="/incident/create" /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/incident/create" 
                element={isLoggedIn ? <IncidentCreationScreen /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/" 
                element={<Navigate to={isLoggedIn ? "/home" : "/login"} />} 
              />
            </Routes>
          </Content>
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;